import { Typography, TypographyProps, BoxProps } from '@mui/material';

type TextProps = TypographyProps & BoxProps;

export default Typography;
export type { TextProps };
